import block from './block.json';

export const sectionCardsPressThemeAttributes = {
	backgroundColor: '@tokens.variants.default.backgroundColor',
	padding: {
		// without control (for Storybook only)
		top: [80, 120],
		bottom: [80, 120],
	},
	uptitle: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-6',
		textAlignment: 'left',
	},
	title: {
		color: '@tokens.variants.default.titleColor',
		typography: '@tokens.typographies.heading-1',
		textAlignment: 'left',
	},
	introduction: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.introduction',
		textAlignment: 'left',
	},
	link: {
		color: '@tokens.variants.default.contentColor',
		typography: '@tokens.typographies.links',
		textAlignment: 'right',
	},
};

export const SectionCardsPressThemeControls: ThemeControlsType = {
	// What's displayed
	title: block.title,

	// Unique string/id of the block (= the key used in theme.json)
	slug: block.slug,

	// styling attributes available for this block
	// ...the same way we define attributes for a gutenberg block
	attributes: sectionCardsPressThemeAttributes,

	// this renders in the Customizer panel
	// ...the same way "<InspectorControls />" renders in the gutenberg panel
	edit: () => null,
};
